var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('ai'),_c('audio',{ref:"audio",attrs:{"hidden":"true","src":require("./assets/img/bigScreen/alarm.mp3")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }